// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { totaljobs as baseTotaljobsTheme } from "@stepstone-genesis/design-tokens";
var totaljobs = extendBaseTheme("totaljobs", baseTotaljobsTheme);
export {
  totaljobs
};
